import React, { PureComponent } from 'react';
import cn from 'classnames';
import Select from 'react-select';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { FormGroup, Label } from 'reactstrap';
import { array, number, func, node } from 'prop-types';

class FlowOffers extends PureComponent {
  static propTypes = {
    offerId: number.isRequired,
    offers: array.isRequired,
    onOfferChange: func.isRequired,
    error: node,
    intl: intlShape.isRequired
  };

  static defaultProps = {
    offers: [],
    onOfferChange() {},
    error: '',
  };

  state = {
    isSelectedHidden: false,
  }

  renderSelectNoResultsText = () => {
    const {intl} = this.props;
    return intl.formatMessage({
      id: 'flow.form.offer.no-results-text',
      defaultMessage: 'Offers not found'
    });
  }

  handleHideSelected = bool => {
    this.setState(() => ({ isSelectedHidden: bool }));
  }

  render() {
    const { className, offerId, offers, onOfferChange, error, disabled, theme, inDomainsForm } = this.props;
    const { isSelectedHidden } = this.state;

    return (
      <FormGroup className={cn(className, 'form-group-upper-label', { 'has-error': error })}>
        <Label for="offers">
          <FormattedMessage id={inDomainsForm ? 'flow.form.choose-offer' : 'flow.form.offer'} defaultMessage="Offer" />
        </Label>
        <Select
          id="offers"
          name="offerId"
          clearable={false}
          value={!isSelectedHidden && offerId}
          placeholder={<FormattedMessage id="main.select" defaultMessage="Select..." />}
          onChange={(...rest) => {
            this.handleHideSelected(false);
            onOfferChange(...rest);
          }}
          autoBlur
          onFocus={() => this.handleHideSelected(true)}
          onBlur={() => this.handleHideSelected(false)}
          options={offers.map(({ title: label, id: value }) => ({
            value,
            label,
          }))}
          disabled={disabled}
          noResultsText={this.renderSelectNoResultsText()}
        />
        {error && <small className="form-text">{error}</small>}
      </FormGroup>
    );
  }
}

export default injectIntl(FlowOffers);
